import { api } from "@/api/client";
import type { NetworkEnv } from "@/network/env";

export type Shop = { code: string; title: string };
export type ShopCategory = { code: string; title: string };
export type ShopProduct = {
  id: string;
  title: string;
  slug?: string;
  gift_product_id?: string | number;
  price_hint_usd?: string | number;
  pay_assets?: string[];
};
export type ShopOrder = {
  id: string;
  title?: string;
  product_id?: string;
  status?: string;
  deliver_status?: string;
  codes?: string[];
  amount_usd?: string | number;
  network_fee_usd?: string | number;
  total_usd?: string | number;
  pay_asset?: string;
  qty?: number;
  gift_product_id?: string | number;
  error?: string;
};

export async function listShops(): Promise<Shop[]> {
  const out = await api<{ shops: Shop[] }>("/shops");
  return out.shops || [];
}

export async function listCategories(shop: string): Promise<ShopCategory[]> {
  const out = await api<{ categories: ShopCategory[] }>(
    `/shops/${encodeURIComponent(shop)}/categories`
  );
  return out.categories || [];
}

export async function listProducts(shop: string, category: string): Promise<ShopProduct[]> {
  const out = await api<{ products: ShopProduct[] }>(
    `/shops/${encodeURIComponent(shop)}/categories/${encodeURIComponent(category)}/products`
  );
  return out.products || [];
}

export async function listOrders(shop: string, token: string): Promise<ShopOrder[]> {
  const out = await api<{ orders: ShopOrder[] }>(
    `/shops/${encodeURIComponent(shop)}/orders?limit=40`,
    {},
    token
  );
  return out.orders || [];
}

export async function getOrder(shop: string, orderId: string, token: string): Promise<ShopOrder> {
  const out = await api<{ order: ShopOrder }>(
    `/shops/${encodeURIComponent(shop)}/orders/${encodeURIComponent(orderId)}`,
    {},
    token
  );
  return out.order;
}

export async function createAndPayOrder(
  shop: string,
  token: string,
  body: { product_id: string; pay_asset: string; networkEnv: NetworkEnv; qty?: number }
): Promise<ShopOrder> {
  const created = await api<{ order: ShopOrder }>(
    `/shops/${encodeURIComponent(shop)}/orders`,
    {
      method: "POST",
      body: JSON.stringify({
        product_id: body.product_id,
        qty: body.qty ?? 1,
        pay_asset: body.pay_asset,
        networkEnv: body.networkEnv,
      }),
    },
    token
  );
  const order = created.order;
  const paid = await api<{ order: ShopOrder }>(
    `/shops/${encodeURIComponent(shop)}/orders/${encodeURIComponent(order.id)}/pay`,
    { method: "POST", body: "{}" },
    token
  );
  return paid.order || order;
}

export function deliverStatusLabel(st: string | undefined): { text: string; cls: string } {
  const s = String(st || "unknown").toLowerCase();
  if (s === "ok" || s === "success") return { text: "موفق", cls: "ok" };
  if (s === "failed" || s === "error") return { text: "ناموفق", cls: "bad" };
  return { text: "نامعلوم", cls: "unk" };
}
